import React from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';

const KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

const PiscesCtaSection = () => (
    <section id="cta" className="lp-cta">
        <div className="lp-cta-card lp-cta-card--dark" data-lp-reveal>
            <div className="lp-cta-glow" aria-hidden="true" />
            <div className="lp-cta-inner">
                <h2>Ready to open your first trading window?</h2>
                <p className="sub">Start with a free eligibility check — 10 minutes, no <br /> commitment.</p>
                <div className="lp-cta-btns">
                    <Link className="lp-btn lp-btn--primary" to={ROUTES.REGISTER}>Start free eligibility check</Link>
                    <a className="lp-cta-btn lp-cta-btn--outline" href={KOALENDAR} target="_blank" rel="noopener noreferrer">Book a call with Mark</a>
                </div>
                <p className="fine">mark.bernstein@diligentsia.co.uk · diligentsia.co.uk</p>
            </div>
        </div>
    </section>
);

export default PiscesCtaSection;
